module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-mask-parent"
  }, [_c('component-title', {
    attrs: {
      "config": _vm.config
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.loadMask
  }), _vm._v(" "), _c('default-chart', {
    attrs: {
      "options": _vm.settings,
      "labels": _vm.labels,
      "items": _vm.items,
      "showLegend": _vm.showLegend,
      "showGrid": _vm.showGrid,
      "dashedLines": _vm.dashedLines,
      "zoom": false,
      "height": 120,
      "selected": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chart-options"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showLegend),
      expression: "showLegend"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showLegend) ? _vm._i(_vm.showLegend, null) > -1 : (_vm.showLegend)
    },
    on: {
      "click": _vm.toggleShowLegend,
      "change": function($event) {
        var $$a = _vm.showLegend,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showLegend = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showLegend = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showLegend = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.t('Show legend')) + "\n      ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showGrid),
      expression: "showGrid"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showGrid) ? _vm._i(_vm.showGrid, null) > -1 : (_vm.showGrid)
    },
    on: {
      "click": _vm.toggleShowGrid,
      "change": function($event) {
        var $$a = _vm.showGrid,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showGrid = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showGrid = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showGrid = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.t('Show grid')) + "\n      ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dashedLines),
      expression: "dashedLines"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.dashedLines) ? _vm._i(_vm.dashedLines, null) > -1 : (_vm.dashedLines)
    },
    on: {
      "click": _vm.toggleDashedLines,
      "change": function($event) {
        var $$a = _vm.dashedLines,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.dashedLines = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.dashedLines = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.dashedLines = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.t('Dashed lines')) + "\n      ")]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.t('Y axis options')) + ":")]), _vm._v("\n        " + _vm._s(_vm.t('Min')) + "\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yAxisTicks.min),
      expression: "yAxisTicks.min"
    }],
    staticClass: "y-axis-option",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.yAxisTicks.min)
    },
    on: {
      "change": _vm.changeYAxisTicks,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.yAxisTicks, "min", $event.target.value)
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.t('Max')) + "\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yAxisTicks.max),
      expression: "yAxisTicks.max"
    }],
    staticClass: "y-axis-option",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.yAxisTicks.max)
    },
    on: {
      "change": _vm.changeYAxisTicks,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.yAxisTicks, "max", $event.target.value)
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.t('Step')) + "\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yAxisTicks.step),
      expression: "yAxisTicks.step"
    }],
    staticClass: "y-axis-option",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.yAxisTicks.step)
    },
    on: {
      "change": _vm.changeYAxisTicks,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.yAxisTicks, "step", $event.target.value)
      }
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44425a0c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chart.vue
// module id = 1279
// module chunks = 2